"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const react_i18next_1 = require("react-i18next");
// This page is shown when a user navigates to a URL that doesn't exist
const NotFoundPage = () => {
    const { t } = (0, react_i18next_1.useTranslation)(['main']);
    return (react_1.default.createElement("div", { className: "survey", id: "notFoundPage" },
        react_1.default.createElement("div", { className: "apptr__form" },
            react_1.default.createElement("div", { className: "survey-page-container" },
                react_1.default.createElement("h2", { className: "survey-page-title" }, t('main:NotFoundPageTitle')),
                react_1.default.createElement("p", null, t('main:NotFoundPageMessage')),
                react_1.default.createElement("p", null,
                    react_1.default.createElement(react_router_1.Link, { to: "/" }, t('auth:BackToHomePage'))),
                react_1.default.createElement("img", { src: "/dist/images/page_images/undraw_location-search_nesh.png", alt: t('main:NotFoundPageTitle'), className: "survey-page-image" })))));
};
exports.default = NotFoundPage;
//# sourceMappingURL=NotFoundPage.js.map